import { takeEvery, put, all } from 'redux-saga/effects';
import _ from 'lodash';

import * as logger from '../utils/logger';
import getBaseUrl from '../utils/base-url';

import { categories } from '../utils/variables';

export const REQUEST_DESIGNS_CATEGORIES_LOAD =
  'designs-categories/REQUEST_DESIGNS_CATEGORIES_LOAD';
export const DESIGNS_CATEGORIES_LOAD_RESPONSE =
  'designs-categories/DESIGNS_CATEGORIES_LOAD_RESPONSE';
export const DESIGNS_CATEGORIES_LOAD_FAIL =
  'designs-categories/DESIGNS_CATEGORIES_LOAD_FAIL';

export const actionCreators = {
  requestDesignsCategoriesLoad: () => ({
    type: REQUEST_DESIGNS_CATEGORIES_LOAD
  })
};

function shouldInclude(categoryId) {
  if (categories.length === 0) {
    return true;
  }
  return _.includes(categories, categoryId.toString());
}

function* loadCategories() {
  try {
    const res = yield fetch(
      getBaseUrl() + `/categories?cache_invalid=` + Math.random(),
      {
        method: 'GET',
        credentials: 'same-origin'
      }
    );

    if (res.status !== 200) {
      yield put({ type: DESIGNS_CATEGORIES_LOAD_FAIL });
      const text = yield res.text();
      logger.error(new Error('designs categories load failed ' + text));
      return;
    }
    const json = yield res.json();

    const isBlank = category =>
      category.id === '24' ||
      category.attributes.title.toLowerCase().indexOf('blank') >= 0;

    const items = json.data.filter(category => {
      if (isBlank(category)) {
        return false;
      }
      const subs = category.relationships.subcategories.data.map(({ id }) =>
        _.find(json.included, child => child.id === id)
      );
      const hasIncludedChild = !!_.find(subs, sub => shouldInclude(sub.id));
      return shouldInclude(category.id) || hasIncludedChild;
    });

    const children = _.filter(json.included, subcategory => {
      if (shouldInclude(subcategory.id)) {
        return true;
      }
      const parentId = subcategory.attributes.parent_category_id;

      if (shouldInclude(parentId)) {
        return true;
      }
    });

    yield put({
      type: DESIGNS_CATEGORIES_LOAD_RESPONSE,
      payload: { items, children }
    });
  } catch (e) {
    logger.error(e);
  }
}

export default function* designsCategoriesSaga() {
  yield all([takeEvery(REQUEST_DESIGNS_CATEGORIES_LOAD, loadCategories)]);
}



// WEBPACK FOOTER //
// ./src/actions/designs-categories.js